import { useMemo } from 'react';

import { useUserContext } from 'src/components/app/context/UserContext';
import type { DateRange } from 'src/components/ui/DateRangePicker';

const useSurveySettings = () => {
  const { currentSurvey, currentSurveySettings } = useUserContext();

  const downloadTypes = useMemo(() => {
    if (currentSurveySettings?.downloadTypes) {
      return currentSurveySettings?.downloadTypes.split(',');
    }
    return [];
  }, [currentSurveySettings?.downloadTypes]);

  const currentTimePeriodStartDate = useMemo(() => {
    if (currentSurveySettings?.currentTimePeriodStartDate) {
      return new Date(currentSurveySettings.currentTimePeriodStartDate);
    }
    return undefined;
  }, [currentSurveySettings?.currentTimePeriodStartDate]);

  const defaultComparisonDateRange: DateRange | undefined = useMemo(() => {
    if (!currentSurveySettings) return undefined;

    const initialDates: DateRange = {};
    if (currentSurveySettings.defaultTimeComparisonStartDate) {
      initialDates.startDate = new Date(
        currentSurveySettings.defaultTimeComparisonStartDate,
      );
    }
    if (currentSurveySettings.defaultTimeComparisonEndDate) {
      initialDates.endDate = new Date(
        currentSurveySettings.defaultTimeComparisonEndDate,
      );
    }
    return initialDates;
  }, [currentSurveySettings]);

  const minRespondentAmount = useMemo(
    () => currentSurvey?.minRespondentAmount,
    [currentSurvey],
  );

  return {
    currentTimePeriodStartDate,
    defaultComparisonDateRange,
    yearOverYearComparisonAvailable:
      currentSurveySettings?.yearOverYearComparisonAvailable ?? false,
    downloadTypes,
    minRespondentAmount,
  };
};

export default useSurveySettings;
